export const appLink = {
    android: "https://play.google.com/store/apps/details?id=com.example",
    ios: "https://apps.apple.com/app/id123456789",
    huawei: "https://appgallery.huawei.com/#/app/C123456"
}
